import Typewriter from "typewriter-effect";
import { useTranslation } from "../../i18n";

function Type() {
  const { t, language } = useTranslation();
  const strings = t("home.typewriter");
  const safeStrings = Array.isArray(strings)
    ? strings
    : ["Software Developer", "Fullstack Developer", "ML Engineer", "Freelancer"];

  return (
    <Typewriter
      key={language} 
      options={{
        autoStart: true,
        loop: true,
        delay: 50,
        deleteSpeed: 50,
      }}
      onInit={(typewriter) => {
        let tw = typewriter;
        safeStrings.forEach((text) => {
          tw = tw.typeString(text).pauseFor(1000).deleteAll();
        });
        tw.start();
      }}
    />
  );
}

export default Type;
